meedy.controller('meedy.popupVacationCreateController', ['$scope', '$state', '$mdDialog', 'meedy.vacationModel', 'applicationModel',
    function ($scope, $state, $mdDialog, vacationModel, applicationModel) {

        function setData() {
            $scope.vacation = new VacationMeedyVO();
            $scope.now = new Date();

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$watch(function () {
                return applicationModel.actionInProgress;
            }, function (newVal) {
                $scope.actionInProgress = newVal;
            });

            $scope.$on(Event.MEEDY.VACATION.CHECK_COLLISIONS.SUCCESS, function(event, list) {
                if(list && list.length > 0) {
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/settings/availability/popup/availability-collisions-popup.html',
                        controller: 'meedy.popupAvailabilityCollisionsController',
                        resolve: {
                            terms: function() {
                                return list;
                            },
                            message: function() {
                                return 'T.MEEDY.MODULE.AVAILABILITY.SAVE_VACATION_CONFIRMATION_MESSAGE';
                            }
                        }
                    }).then(function() {
                        $mdDialog.hide($scope.vacation);
                    }, function(error){

                    })
                } else {
                    $mdDialog.hide($scope.vacation);
                }
            });
        }

        function setActions() {
            $scope.save = function () {
                $scope.forms.vacation.$setSubmitted();
                if($scope.forms.vacation.$valid) {
                    vacationModel.checkCollisions($scope.vacation);
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);